
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93_H5D1F8hIK4AzF6RBvTQTkeU3yecRJ3sxVKolWgE5XgMeta } from "/opt/simploshop/shared/core-theme/app/pages/[...slug].vue?macro=true";
import { default as deliverysGL0GbG_bo_bLuJNpVLOS0YHRFsi8dLV8UWuPBUTXOcMeta } from "/opt/simploshop/themes/demo/app/pages/cart/delivery.vue?macro=true";
import { default as indexcdezDqVRkcts1dyWUuPhVdPWUVNtVvRsUWXiqAcRTYkMeta } from "/opt/simploshop/themes/demo/app/pages/cart/index.vue?macro=true";
import { default as shipping_45and_45paymentipVD1xgWz_45SQF5JB1jskcIGL0XA0UdtrBW6qiQ0CR38Meta } from "/opt/simploshop/themes/demo/app/pages/cart/shipping-and-payment.vue?macro=true";
import { default as summaryWlV_6vaAZ05_45Wi4RmCRg1hIAuxynuk3Qm3MVIMQbk_YMeta } from "/opt/simploshop/themes/demo/app/pages/cart/summary.vue?macro=true";
import { default as cartbXi2TFQZliugUnZ3FLDgkhbWt6s7Uu7RXyxkOvIGGxAMeta } from "/opt/simploshop/themes/demo/app/pages/cart.vue?macro=true";
import { default as accountesfqHaZKwAbyrl24nOyQM46vbt6k0w2Dkv26qTJJnt8Meta } from "/opt/simploshop/themes/demo/app/pages/customer/account.vue?macro=true";
import { default as dashboardv0ARMwJn84J0Hh15JfDzE3xyYQ7JZ5Bw_GimANY4jR4Meta } from "/opt/simploshop/themes/demo/app/pages/customer/dashboard.vue?macro=true";
import { default as favorite_45productsjCqwW6SpA3jGFQSORWe8X67Hd_Z0sQBIEl_1oE_459agAMeta } from "/opt/simploshop/themes/demo/app/pages/customer/favorite-products.vue?macro=true";
import { default as my_45addresseskBaVkJTW_ZQTZvYMrrvClLWUIY4duBdD6wPA0vbBwjoMeta } from "/opt/simploshop/themes/demo/app/pages/customer/my-addresses.vue?macro=true";
import { default as _91id_934lykBFih8lVPW9QIHRLRjqTb8W7kfW4q53JOoVcT69UMeta } from "/opt/simploshop/themes/demo/app/pages/customer/my-orders/[id].vue?macro=true";
import { default as indexJPtqq_45gzlNlFwmetSkDUK_45KUf0NUELKaLsVGEzIEpQYMeta } from "/opt/simploshop/themes/demo/app/pages/customer/my-orders/index.vue?macro=true";
import { default as my_45ordersSIqGdorfZICZXorCinhguSjnNU9_45rHjOjgHs_45_45eBeqEMeta } from "/opt/simploshop/themes/demo/app/pages/customer/my-orders.vue?macro=true";
import { default as customerds3Z_8M9BjLskm64F0BnvJWkQgDjHRHUfTWMGR2nCssMeta } from "/opt/simploshop/themes/demo/app/pages/customer.vue?macro=true";
import { default as index__J3P1zAIlcrfOrTuYiKXfyf_458lC0fTBXcOVblDEQv4Meta } from "/opt/simploshop/themes/demo/app/pages/index.vue?macro=true";
import { default as loginEgCid12P0Ah9bu5IuFHPy8k7qYTkAbxlfar79j5ibAYMeta } from "/opt/simploshop/themes/demo/app/pages/login.vue?macro=true";
import { default as password_45resetjO1Z95ANK7Iai_45eMOG9WdnqD2t8u_CRZafQcFMaNAXgMeta } from "/opt/simploshop/themes/demo/app/pages/password-reset.vue?macro=true";
export default [
  {
    name: "slug___cs",
    path: "/:slug(.*)*",
    component: () => import("/opt/simploshop/shared/core-theme/app/pages/[...slug].vue")
  },
  {
    name: "slug___sk",
    path: "/:slug(.*)*",
    component: () => import("/opt/simploshop/shared/core-theme/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/opt/simploshop/shared/core-theme/app/pages/[...slug].vue")
  },
  {
    name: cartbXi2TFQZliugUnZ3FLDgkhbWt6s7Uu7RXyxkOvIGGxAMeta?.name,
    path: "/cart",
    meta: cartbXi2TFQZliugUnZ3FLDgkhbWt6s7Uu7RXyxkOvIGGxAMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart.vue"),
    children: [
  {
    name: "cart-delivery___cs",
    path: "/kosik/doruceni",
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/delivery.vue")
  },
  {
    name: "cart___cs",
    path: "/kosik",
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/index.vue")
  },
  {
    name: "cart-shipping-and-payment___cs",
    path: "/kosik/doprava-a-platba",
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/shipping-and-payment.vue")
  },
  {
    name: "cart-summary___cs",
    path: "summary",
    meta: summaryWlV_6vaAZ05_45Wi4RmCRg1hIAuxynuk3Qm3MVIMQbk_YMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/summary.vue")
  }
]
  },
  {
    name: cartbXi2TFQZliugUnZ3FLDgkhbWt6s7Uu7RXyxkOvIGGxAMeta?.name,
    path: "/cart",
    meta: cartbXi2TFQZliugUnZ3FLDgkhbWt6s7Uu7RXyxkOvIGGxAMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart.vue"),
    children: [
  {
    name: "cart-delivery___sk",
    path: "/kosik/dorucenie",
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/delivery.vue")
  },
  {
    name: "cart___sk",
    path: "/kosik",
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/index.vue")
  },
  {
    name: "cart-shipping-and-payment___sk",
    path: "/kosik/doprava-a-platba",
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/shipping-and-payment.vue")
  },
  {
    name: "cart-summary___sk",
    path: "summary",
    meta: summaryWlV_6vaAZ05_45Wi4RmCRg1hIAuxynuk3Qm3MVIMQbk_YMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/summary.vue")
  }
]
  },
  {
    name: cartbXi2TFQZliugUnZ3FLDgkhbWt6s7Uu7RXyxkOvIGGxAMeta?.name,
    path: "/cart",
    meta: cartbXi2TFQZliugUnZ3FLDgkhbWt6s7Uu7RXyxkOvIGGxAMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart.vue"),
    children: [
  {
    name: "cart-delivery___en",
    path: "delivery",
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/delivery.vue")
  },
  {
    name: "cart___en",
    path: "/my-cart",
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/index.vue")
  },
  {
    name: "cart-shipping-and-payment___en",
    path: "shipping-and-payment",
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/shipping-and-payment.vue")
  },
  {
    name: "cart-summary___en",
    path: "summary",
    meta: summaryWlV_6vaAZ05_45Wi4RmCRg1hIAuxynuk3Qm3MVIMQbk_YMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/cart/summary.vue")
  }
]
  },
  {
    name: "customer___cs",
    path: "/customer",
    meta: customerds3Z_8M9BjLskm64F0BnvJWkQgDjHRHUfTWMGR2nCssMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer.vue"),
    children: [
  {
    name: "customer-account___cs",
    path: "/zakaznik/informace-o-uctu",
    meta: accountesfqHaZKwAbyrl24nOyQM46vbt6k0w2Dkv26qTJJnt8Meta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/account.vue")
  },
  {
    name: "customer-dashboard___cs",
    path: "/zakaznik/dashboard",
    meta: dashboardv0ARMwJn84J0Hh15JfDzE3xyYQ7JZ5Bw_GimANY4jR4Meta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/dashboard.vue")
  },
  {
    name: "customer-favorite-products___cs",
    path: "/zakaznik/oblibene-produkty",
    meta: favorite_45productsjCqwW6SpA3jGFQSORWe8X67Hd_Z0sQBIEl_1oE_459agAMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/favorite-products.vue")
  },
  {
    name: "customer-my-addresses___cs",
    path: "/zakaznik/adresar",
    meta: my_45addresseskBaVkJTW_ZQTZvYMrrvClLWUIY4duBdD6wPA0vbBwjoMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-addresses.vue")
  },
  {
    name: my_45ordersSIqGdorfZICZXorCinhguSjnNU9_45rHjOjgHs_45_45eBeqEMeta?.name,
    path: "/zakaznik/moje-objednavky",
    meta: my_45ordersSIqGdorfZICZXorCinhguSjnNU9_45rHjOjgHs_45_45eBeqEMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-orders.vue"),
    children: [
  {
    name: "customer-my-orders-id___cs",
    path: "/zakaznik/objednavka/:id()",
    meta: _91id_934lykBFih8lVPW9QIHRLRjqTb8W7kfW4q53JOoVcT69UMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-orders/[id].vue")
  },
  {
    name: "customer-my-orders___cs",
    path: "",
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-orders/index.vue")
  }
]
  }
]
  },
  {
    name: "customer___sk",
    path: "/customer",
    meta: customerds3Z_8M9BjLskm64F0BnvJWkQgDjHRHUfTWMGR2nCssMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer.vue"),
    children: [
  {
    name: "customer-account___sk",
    path: "/zakaznik/informacie-o-ucte",
    meta: accountesfqHaZKwAbyrl24nOyQM46vbt6k0w2Dkv26qTJJnt8Meta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/account.vue")
  },
  {
    name: "customer-dashboard___sk",
    path: "/zakaznik/dashboard",
    meta: dashboardv0ARMwJn84J0Hh15JfDzE3xyYQ7JZ5Bw_GimANY4jR4Meta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/dashboard.vue")
  },
  {
    name: "customer-favorite-products___sk",
    path: "/zakaznik/oblubene-produkty",
    meta: favorite_45productsjCqwW6SpA3jGFQSORWe8X67Hd_Z0sQBIEl_1oE_459agAMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/favorite-products.vue")
  },
  {
    name: "customer-my-addresses___sk",
    path: "/zakaznik/adresar",
    meta: my_45addresseskBaVkJTW_ZQTZvYMrrvClLWUIY4duBdD6wPA0vbBwjoMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-addresses.vue")
  },
  {
    name: my_45ordersSIqGdorfZICZXorCinhguSjnNU9_45rHjOjgHs_45_45eBeqEMeta?.name,
    path: "/zakaznik/moje-objednavky",
    meta: my_45ordersSIqGdorfZICZXorCinhguSjnNU9_45rHjOjgHs_45_45eBeqEMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-orders.vue"),
    children: [
  {
    name: "customer-my-orders-id___sk",
    path: "/zakaznik/objednavka/:id()",
    meta: _91id_934lykBFih8lVPW9QIHRLRjqTb8W7kfW4q53JOoVcT69UMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-orders/[id].vue")
  },
  {
    name: "customer-my-orders___sk",
    path: "",
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-orders/index.vue")
  }
]
  }
]
  },
  {
    name: "customer___en",
    path: "/customer",
    meta: customerds3Z_8M9BjLskm64F0BnvJWkQgDjHRHUfTWMGR2nCssMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer.vue"),
    children: [
  {
    name: "customer-account___en",
    path: "account",
    meta: accountesfqHaZKwAbyrl24nOyQM46vbt6k0w2Dkv26qTJJnt8Meta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/account.vue")
  },
  {
    name: "customer-dashboard___en",
    path: "dashboard",
    meta: dashboardv0ARMwJn84J0Hh15JfDzE3xyYQ7JZ5Bw_GimANY4jR4Meta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/dashboard.vue")
  },
  {
    name: "customer-favorite-products___en",
    path: "favorite-products",
    meta: favorite_45productsjCqwW6SpA3jGFQSORWe8X67Hd_Z0sQBIEl_1oE_459agAMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/favorite-products.vue")
  },
  {
    name: "customer-my-addresses___en",
    path: "my-addresses",
    meta: my_45addresseskBaVkJTW_ZQTZvYMrrvClLWUIY4duBdD6wPA0vbBwjoMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-addresses.vue")
  },
  {
    name: my_45ordersSIqGdorfZICZXorCinhguSjnNU9_45rHjOjgHs_45_45eBeqEMeta?.name,
    path: "my-orders",
    meta: my_45ordersSIqGdorfZICZXorCinhguSjnNU9_45rHjOjgHs_45_45eBeqEMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-orders.vue"),
    children: [
  {
    name: "customer-my-orders-id___en",
    path: "/customer/order/:id()",
    meta: _91id_934lykBFih8lVPW9QIHRLRjqTb8W7kfW4q53JOoVcT69UMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-orders/[id].vue")
  },
  {
    name: "customer-my-orders___en",
    path: "",
    component: () => import("/opt/simploshop/themes/demo/app/pages/customer/my-orders/index.vue")
  }
]
  }
]
  },
  {
    name: "index___cs",
    path: "/",
    meta: index__J3P1zAIlcrfOrTuYiKXfyf_458lC0fTBXcOVblDEQv4Meta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/index.vue")
  },
  {
    name: "index___sk",
    path: "/",
    meta: index__J3P1zAIlcrfOrTuYiKXfyf_458lC0fTBXcOVblDEQv4Meta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: index__J3P1zAIlcrfOrTuYiKXfyf_458lC0fTBXcOVblDEQv4Meta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/index.vue")
  },
  {
    name: "login___cs",
    path: "/prihlaseni",
    meta: loginEgCid12P0Ah9bu5IuFHPy8k7qYTkAbxlfar79j5ibAYMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/login.vue")
  },
  {
    name: "login___sk",
    path: "/prihlasenie",
    meta: loginEgCid12P0Ah9bu5IuFHPy8k7qYTkAbxlfar79j5ibAYMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginEgCid12P0Ah9bu5IuFHPy8k7qYTkAbxlfar79j5ibAYMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/login.vue")
  },
  {
    name: "password-reset___cs",
    path: "/obnova-hesla",
    meta: password_45resetjO1Z95ANK7Iai_45eMOG9WdnqD2t8u_CRZafQcFMaNAXgMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___sk",
    path: "/obnova-hesla",
    meta: password_45resetjO1Z95ANK7Iai_45eMOG9WdnqD2t8u_CRZafQcFMaNAXgMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___en",
    path: "/password-reset",
    meta: password_45resetjO1Z95ANK7Iai_45eMOG9WdnqD2t8u_CRZafQcFMaNAXgMeta || {},
    component: () => import("/opt/simploshop/themes/demo/app/pages/password-reset.vue")
  }
]